import './style.sass';

import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

const RulesBlock = ({ listRules }) => {
    return (
        <FullWrapper caseName="rules-block">
            <div className="rules-block__subtitle">Правила работы с&nbsp;SEO-статьями:</div>
            <div className="rules-block__wrapper">
                <div className="rules-block__container">
                    {listRules.map(item => (
                        <div key={item.id} className="rules-block__inner">
                            <div key={item.id} className="rules-block__item">
                                <div className="rules-block__item-top">
                                    <img
                                        src={item.icon}
                                        alt="rule-icon"
                                        className="rules-block__item-top__icon"
                                    ></img>
                                    <div className="rules-block__item-top__number">
                                        {item.number}
                                    </div>
                                </div>
                                <div
                                    dangerouslySetInnerHTML={{ __html: item.text }}
                                    className="rules-block__item-bottom"
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </FullWrapper>
    );
};

export default RulesBlock;
